import { Dialog, DialogContent, useMediaQuery, useTheme } from "@mui/material";
import { DialogProps } from "@toolpad/core";
import { PreprocessStep } from "./PreprocessStep";

/**
 * BulkImportDialog component
 */
export const BulkImportDialog = ({ open, onClose }: DialogProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Dialog
            open={open}
            onClose={() => onClose()}
            maxWidth={"lg"}
            fullWidth
            fullScreen={isMobile}
            PaperProps={{
                sx: {
                    maxHeight: isMobile ? "auto" : "800px",
                    height: isMobile ? "100%" : "90%",
                },
            }}
        >
            <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
                <PreprocessStep onClose={onClose} />
            </DialogContent>
        </Dialog>
    );
};
